import {
  getEstimateContractByIdAPI,
  updatePortDistanceForContractAPI,
  resetPortDistanceForContractAPI,
  savePortDistanceAPI,
  estimateContractcargoPriceAPI,
  estimateContractcargoPriceDetailedAPI,
  updateEstimateCostAPI,
  deleteCargoForEstimateByIdAPI,
  addCargoForEstimateAPI,
  createEstimateContractAPI,
  updateEstimateCargoAPI,
  updateVesselContractAPI,
} from "../../api";

export const getEstimateContractByIdApi = (data) =>
  getEstimateContractByIdAPI(data);

export const updatePortDistanceForContractApi = (data) =>
  updatePortDistanceForContractAPI(data);

export const resetPortDistanceForContractApi = (data) =>
  resetPortDistanceForContractAPI(data);

export const savePortDistanceApi = (data) =>
  savePortDistanceAPI(data);

export const estimateContractcargoPriceApi = (data) =>
  estimateContractcargoPriceAPI(data);

export const estimateContractcargoPriceDetailedApi = (data) =>
  estimateContractcargoPriceDetailedAPI(data);

export const updateEstimateCostApi = (data) =>
  updateEstimateCostAPI(data);

export const deleteCargoFromEstimateByIdApi = (data) =>
  deleteCargoForEstimateByIdAPI(data);

export const addCargoForEstimateApi = (data) =>
  addCargoForEstimateAPI(data);

export const createEstimateContractApi = (data) =>
  createEstimateContractAPI(data);

export const updateEstimateCargoApi = (idObj, formPayload) =>
  updateEstimateCargoAPI(idObj, formPayload);

export const updateVesselContractApi = (idObj, formPayload) =>
  updateVesselContractAPI(idObj, formPayload);
